export default __webpack_public_path__ + "static/media/calendar_edit.37ab002d.svg";